<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-sheet class="mb-2"
        ><v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Details</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Job title</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow mx-2"
                    v-model="profileData.jobTitle"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Start date</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        :value="profileData.startDate"
                        class="field-narrow px-2"
                        v-on="on"
                        v-bind="attrs"
                        readonly
                        :clearable="true"
                        @click:clear="removeStartDate"
                      />
                    </template>
                    <v-date-picker
                      :value="profileData.startDate"
                      @input="selectStartDate"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Job type</div>
                </v-col>
                <v-col cols="6" md="4" class="pa-0">
                  <v-select
                    filled
                    :items="['Permanent', 'Temporary']"
                    class="select-narrow px-2"
                    v-model="restrictedProfileData.employment.jobType"
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" md="4" class="pa-0">
                  <v-select
                    filled
                    class="select-narrow px-2"
                    :items="['Full time', 'Part time']"
                    v-model="restrictedProfileData.employment.fullOrPartTime"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Contact</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Email</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    :value="profileData.email"
                    :disabled="true"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Work landline</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    v-model="restrictedProfileData.employment.landline"
                    class="field-narrow px-2"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="8" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="2" class="pa-0">
                  <div class="text-section-title">Work mobile</div>
                </v-col>
                <v-col cols="12" md="8" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.employment.mobile"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0"><h2>Holidays</h2></v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" class="pa-0">
              <v-row class="ma-0" align="center">
                <div class="text-section-title">Allowance</div>

                <v-text-field
                  filled
                  class="field-narrow px-2 ml-4"
                  style="max-width: 57px"
                  v-model.number="restrictedProfileData.holidays.allowance"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
      <v-sheet>
        <v-skeleton-loader type="article" v-if="loading"></v-skeleton-loader>
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0">
            <h2>Access Roles</h2>
          </v-row>
          <v-row class="mx-0 my-3">
            <roles-list v-model="profileData.roles"></roles-list>
          </v-row>
        </v-col>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import RolesList from './Roles.vue'

export default {
  props: ['id', 'profileData', 'restrictedProfileData'],
  components: {
    RolesList,
  },
  data: () => ({
    startDateMenu: false,
  }),
  computed: {
    loading() {
      return !this.profileData || !this.restrictedProfileData
    },
    fullName() {
      return [
        this.profileData.firstName ?? '',
        this.profileData.lastName ?? '',
      ].join(' ')
    },
  },
  methods: {
    selectStartDate(date) {
      this.profileData.startDate = date
      this.startDateMenu = false
    },
    removeStartDate() {
      delete this.profileData.startDate
    },
  },
}
</script>

<style lang="sass" scoped>
.avatar-name
  @include tabInactive
</style>


